import {
  CLEAR_SOCIAL_TOKEN_REQUEST,
  CLEAR_SOCIAL_TOKEN_SUCCESS,
  SET_ASSOCIATED_FBPAGE_REQUEST,
  SET_ASSOCIATED_FBPAGE_SUCCESS,
  SET_FB_TOKEN_SUCCESS,
  SET_YOUTUBE_ACC_TOKEN_SUCCESS,
  SET_TWITTER_ACC_TOKEN_SUCCESS,
  SET_SUBSCRIBE_INSTAGRAM_MENTIONS_REQUEST,
  SET_SUBSCRIBE_INSTAGRAM_MENTIONS_SUCCESS,
  GET_COMPETITION_SUCCESS,
  UPDATE_COMPETITION_SUCCESS,
  GET_COMPETITION_MEMBER_LIST_SUCCESS,
  CLEAR_ENTITY,
  INVITE_COMPETITION_MEMBERS_SUCCESS,
  REMOVE_COMPETITION_MEMBER_SUCCESS,
  UPDATE_COMPETITION_EMBED_URL_SUCCESS,
  GET_COMPETITION_META_SUCCESS,
  UPDATE_COMPETITION_SHARE_MESSAGING_SUCCESS,
  BLOCK_COMPETITION_WORDS_REQUEST,
  UNBLOCK_COMPETITION_WORDS_REQUEST,
  TOGGLE_COMPETITION_WORD_BLACKLIST_REQUEST,
  SET_COMPETITION_META_REQUEST,
  SET_COMPETITION_META_SUCCESS,
  UPDATE_COMPETITION_MEMBER_ROLE_REQUEST,
  UPDATE_COMPETITION_MEMBER_ROLE_SUCCESS,
  COMPETITION_UNBLOCK_USERNAME,
  COMPETITION_BLOCK_USERNAME,
  SAVE_COMPETITION_STAGES_SUCCESS,
  SAVE_COMPETITION_MESSAGING_SUCCESS,
  SAVE_COMPETITION_BACKGROUND_MEDIA_SUCCESS,
  SAVE_COMPETITION_PRIZEIMAGE_MEDIA_SUCCESS,
  SAVE_COMPETITION_INTROVIDEO_MEDIA_SUCCESS,
  SAVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_SUCCESS,
  SAVE_COMPETITION_LOGO_MEDIA_SUCCESS,
  REMOVE_COMPETITION_BACKGROUND_MEDIA_SUCCESS,
  REMOVE_COMPETITION_INTROVIDEO_MEDIA_SUCCESS,
  REMOVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_SUCCESS,
  REMOVE_COMPETITION_ADIMAGE1_MEDIA_SUCCESS,
  REMOVE_COMPETITION_ADIMAGE2_MEDIA_SUCCESS,
  REMOVE_COMPETITION_ADIMAGE3_MEDIA_SUCCESS,
  REMOVE_COMPETITION_ADVIDEO1_MEDIA_SUCCESS,
  REMOVE_COMPETITION_ADVIDEO2_MEDIA_SUCCESS,
  REMOVE_COMPETITION_ADVIDEO3_MEDIA_SUCCESS,
  REMOVE_COMPETITION_LOGO_MEDIA_SUCCESS,
  REMOVE_COMPETITION_WATERMARK_MEDIA_SUCCESS,
  ACCEPT_COMPETITION_TERMS_SUCCESS,
  SAVE_COMPETITION_TYPE_SUCCESS,
  APPROVE_COMPETITION_STAGE_SUCCESS,
  UNPUBLISH_COMPETITION_SUCCESS,
  PUBLISH_COMPETITION_SUCCESS,
  SET_COMMENT_POST_REQUEST,
  SET_COMMENT_POST_SUCCESS,
  UPDATE_CUSTOM_CSS_SUCCESS,
  APPROVE_COMPETITION_STAGE_REQUEST,
  REQUIRE_COMPETITION_WORDS_REQUEST,
  REMOVE_REQUIRED_COMPETITION_WORD_REQUEST,
  FORCE_ADVANCE_ENTRY_SUCCESS,
  FORCE_REMOVE_ENTRY_STAGE_SUCCESS,
  PREVIEW_SEED_COMPETITION_SUCCESS,
  PREVIEW_ADVANCE_COMPETITION_SUCCESS,
  CREATE_ENTRY_SUCCESS,
  SAVE_COMPETITION_INTROCOVER_MEDIA_SUCCESS,
  REMOVE_COMPETITION_INTROCOVER_MEDIA_SUCCESS,
  SET_COMPETITION,
} from '../constants';
import { createReducer } from './Utils';
import { CompetitionState, FunctionMap } from '../../types';
import {
  addNewEntityMembers,
  clearEntitySocialToken,
  entityBlockUsername,
  entityBlockWord,
  entityToggleWordBlackList,
  entityUnblockUserName,
  entityUnblockWord,
  removeEntityUser,
  setCommentPostForNetwork,
  setCommentPostForNetworkOpt,
  setEntity,
  setEntityAssociatedFBPage,
  setEntityMemberRole,
  setEntityMemberRoleOptimistic,
  setEntityMembers,
  setEntityMeta,
  setEntitySocialToken,
  setEntitySubscribedInstagramMentions,
  updateEntity,
  setCustomCSS,
  entityAddRequiredWords,
  entityRemoveRequiredWord,
} from './common/Entity';
import { FSAInterface } from '../actions';
import get from 'lodash/fp/get';
import getOr from 'lodash/fp/getOr';
import set from 'lodash/fp/set';
import {
  CompetitionMessagingInt,
  CompetitionMeta,
  CompetitionScheduling,
  CompetitionStages,
} from '../../models/Competition';

const initialState = {
  members: [],
  keywords: [],
};

function clearCompetition() {
  return initialState;
}

function setStages(
  state: CompetitionState,
  action: FSAInterface<{ stages: CompetitionStages; scheduling: CompetitionScheduling }>,
) {
  const stages = get('payload.stages', action);
  const scheduling = get('payload.scheduling', action);
  return { ...state, stages: { ...stages }, scheduling: { ...scheduling } };
}

function setMessaging(state: CompetitionState, action: FSAInterface<{ messaging: CompetitionMessagingInt }>) {
  const { messaging: currentMessaging } = state;
  const messaging = get('payload.messaging', action);
  return { ...state, messaging: { ...currentMessaging, ...messaging } };
}

function setMedia(state: CompetitionState, action: FSAInterface<{ metadata: CompetitionMeta }>) {
  const media = get('payload.media', action);
  return { ...state, media: { ...media } };
}

function setTermsAccepted(state: CompetitionState, action: FSAInterface<{ metadata: CompetitionMeta }>) {
  const { termsAccepted } = get('payload.metadata', action);
  return { ...state, termsAccepted };
}

function setType(state: CompetitionState, action: FSAInterface<{ metadata: CompetitionMeta }>) {
  const {
    submissionType,
    tags,
    adminEmail,
    adminPhone,
    oauthEnabled,
    embedUrl,
    mediaFilterType,
    hideVoteCount,
    targetEndDate,
    endNum,
    targetWinnerCount,
    singleVote,
    isAnonymousVotingEnabled,
    isSubscribeOptionChecked,
    mediaMaxLimit,
  } = get('payload.metadata', action);
  const scheduling = get('payload.scheduling', action);
  const stages = get('payload.stages', action);
  return {
    ...state,
    submissionType,
    tags,
    adminEmail,
    adminPhone,
    scheduling,
    stages,
    oauthEnabled,
    embedUrl,
    mediaFilterType,
    hideVoteCount,
    targetEndDate,
    endNum,
    targetWinnerCount,
    singleVote,
    isAnonymousVotingEnabled,
    isSubscribeOptionChecked,
    mediaMaxLimit,
  };
}

function setPublished(state: CompetitionState, action: FSAInterface<{ metadata: CompetitionMeta; currentStage: number }>) {
  const { published } = get('payload.metadata', action);
  const currentStage = get('payload.currentStage', action);
  const stages = get('payload.stages', action);
  return { ...state, published, currentStage, stages };
}

function approveStageOptimistic(state: CompetitionState, action: FSAInterface<{ approved: boolean }>) {
  const stages = set([`stage${action?.meta?.stageNum}`, 'winnersApproved'], action.payload?.approved, state.stages);

  return { ...state, stages };
}

function incrementStageEntryCount(state: CompetitionState, action: FSAInterface<any>) {
  const currentPostCount = getOr(0, [`stage${action?.meta?.stageToAdvance || 0}`, 'postCount'], state.stages);
  let incCount;
  if (action?.meta?.stageToAdvance) {
    incCount = 1;
  } else if (action?.payload?.length) {
    incCount = action?.payload?.length;
  } else {
    incCount = 1;
  }

  const stages = set([`stage${action?.meta?.stageToAdvance || 0}`, 'postCount'], currentPostCount + incCount, state.stages);
  return {
    ...state,
    stages,
  };
}

function decrementStageEntryCount(state: CompetitionState, action: FSAInterface<any>) {
  const currentPostCount = get([`stage${action?.meta?.stageToRemove}`, 'postCount'], state.stages);
  const stages = set([`stage${action?.meta?.stageToRemove}`, 'postCount'], currentPostCount - 1, state.stages);
  return {
    ...state,
    stages,
  };
}

const functionMap: FunctionMap = {
  [GET_COMPETITION_SUCCESS]: setEntity,
  [CLEAR_ENTITY]: clearCompetition,
  [SET_FB_TOKEN_SUCCESS]: setEntitySocialToken,
  [CLEAR_SOCIAL_TOKEN_REQUEST]: clearEntitySocialToken,
  [CLEAR_SOCIAL_TOKEN_SUCCESS]: clearEntitySocialToken,
  [SET_ASSOCIATED_FBPAGE_REQUEST]: setEntityAssociatedFBPage,
  [SET_ASSOCIATED_FBPAGE_SUCCESS]: setEntityAssociatedFBPage,
  [SET_SUBSCRIBE_INSTAGRAM_MENTIONS_REQUEST]: setEntitySubscribedInstagramMentions,
  [SET_SUBSCRIBE_INSTAGRAM_MENTIONS_SUCCESS]: setEntitySubscribedInstagramMentions,
  [SET_YOUTUBE_ACC_TOKEN_SUCCESS]: setEntitySocialToken,
  [SET_TWITTER_ACC_TOKEN_SUCCESS]: setEntitySocialToken,
  [UPDATE_COMPETITION_SUCCESS]: updateEntity,
  [GET_COMPETITION_MEMBER_LIST_SUCCESS]: setEntityMembers,
  [INVITE_COMPETITION_MEMBERS_SUCCESS]: addNewEntityMembers,
  [REMOVE_COMPETITION_MEMBER_SUCCESS]: removeEntityUser,
  [UPDATE_COMPETITION_EMBED_URL_SUCCESS]: setEntityMeta,
  [GET_COMPETITION_META_SUCCESS]: setEntityMeta,
  [UPDATE_COMPETITION_SHARE_MESSAGING_SUCCESS]: setEntityMeta,
  [BLOCK_COMPETITION_WORDS_REQUEST]: entityBlockWord,
  [UNBLOCK_COMPETITION_WORDS_REQUEST]: entityUnblockWord,
  [TOGGLE_COMPETITION_WORD_BLACKLIST_REQUEST]: entityToggleWordBlackList,
  [SET_COMPETITION_META_REQUEST]: setEntityMeta,
  [SET_COMPETITION_META_SUCCESS]: setEntityMeta,
  [UPDATE_COMPETITION_MEMBER_ROLE_REQUEST]: setEntityMemberRoleOptimistic,
  [UPDATE_COMPETITION_MEMBER_ROLE_SUCCESS]: setEntityMemberRole,
  [COMPETITION_UNBLOCK_USERNAME]: entityUnblockUserName,
  [COMPETITION_BLOCK_USERNAME]: entityBlockUsername,
  [SAVE_COMPETITION_STAGES_SUCCESS]: setStages,
  [SAVE_COMPETITION_MESSAGING_SUCCESS]: setMessaging,
  [SAVE_COMPETITION_BACKGROUND_MEDIA_SUCCESS]: setMedia,
  [SAVE_COMPETITION_PRIZEIMAGE_MEDIA_SUCCESS]: setMedia,
  [SAVE_COMPETITION_INTROVIDEO_MEDIA_SUCCESS]: setMedia,
  [SAVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_SUCCESS]: setMedia,
  [SAVE_COMPETITION_LOGO_MEDIA_SUCCESS]: setMedia,
  [SAVE_COMPETITION_INTROCOVER_MEDIA_SUCCESS]: setMedia,
  [REMOVE_COMPETITION_BACKGROUND_MEDIA_SUCCESS]: setMedia,
  [REMOVE_COMPETITION_INTROVIDEO_MEDIA_SUCCESS]: setMedia,
  [REMOVE_COMPETITION_CONFIRMATIONVIDEO_MEDIA_SUCCESS]: setMedia,
  [REMOVE_COMPETITION_ADIMAGE1_MEDIA_SUCCESS]: setMedia,
  [REMOVE_COMPETITION_ADIMAGE2_MEDIA_SUCCESS]: setMedia,
  [REMOVE_COMPETITION_ADIMAGE3_MEDIA_SUCCESS]: setMedia,
  [REMOVE_COMPETITION_ADVIDEO1_MEDIA_SUCCESS]: setMedia,
  [REMOVE_COMPETITION_ADVIDEO2_MEDIA_SUCCESS]: setMedia,
  [REMOVE_COMPETITION_ADVIDEO3_MEDIA_SUCCESS]: setMedia,
  [REMOVE_COMPETITION_LOGO_MEDIA_SUCCESS]: setMedia,
  [REMOVE_COMPETITION_INTROCOVER_MEDIA_SUCCESS]: setMedia,
  [REMOVE_COMPETITION_WATERMARK_MEDIA_SUCCESS]: setMedia,
  [ACCEPT_COMPETITION_TERMS_SUCCESS]: setTermsAccepted,
  [SAVE_COMPETITION_TYPE_SUCCESS]: setType,
  [APPROVE_COMPETITION_STAGE_REQUEST]: approveStageOptimistic,
  [APPROVE_COMPETITION_STAGE_SUCCESS]: setEntity,
  [PUBLISH_COMPETITION_SUCCESS]: setPublished,
  [UNPUBLISH_COMPETITION_SUCCESS]: setPublished,
  [SET_COMMENT_POST_REQUEST]: setCommentPostForNetworkOpt,
  [SET_COMMENT_POST_SUCCESS]: setCommentPostForNetwork,
  [UPDATE_CUSTOM_CSS_SUCCESS]: setCustomCSS,
  [REQUIRE_COMPETITION_WORDS_REQUEST]: entityAddRequiredWords,
  [REMOVE_REQUIRED_COMPETITION_WORD_REQUEST]: entityRemoveRequiredWord,
  [FORCE_ADVANCE_ENTRY_SUCCESS]: incrementStageEntryCount,
  [FORCE_REMOVE_ENTRY_STAGE_SUCCESS]: decrementStageEntryCount,
  [PREVIEW_SEED_COMPETITION_SUCCESS]: incrementStageEntryCount,
  [PREVIEW_ADVANCE_COMPETITION_SUCCESS]: setEntity,
  [CREATE_ENTRY_SUCCESS]: incrementStageEntryCount,
  [SET_COMPETITION]: setEntity,
};

export default createReducer(functionMap, initialState);
